import { useEffect, useRef, useState } from 'react';

// Lightweight common-emoji grid. No third-party dep — we only need ~50 picks
// to cover what's shown in the chat_emojis mock.
const GROUPS: Record<string, string[]> = {
  Smileys: ['😀', '😁', '😂', '🤣', '😊', '😍', '😘', '😜', '🤩', '🤔', '🙃', '😐', '😴', '🤯', '🥳', '😇'],
  Hands: ['👍', '👎', '👏', '🙌', '🙏', '👌', '✌️', '🤞', '🤝', '💪'],
  Hearts: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💔', '💯'],
  Work: ['📄', '📎', '📝', '🗂️', '📁', '📌', '📅', '⏰', '✅', '❌', '⚖️', '💼'],
  Misc: ['🎉', '🔥', '⭐', '✨', '🚀', '💡', '❓', '❗', '☑️', '🕒'],
};

export function EmojiPicker({
  onPick,
  onClose,
}: {
  onPick: (emoji: string) => void;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(Object.keys(GROUPS)[0]);

  useEffect(() => {
    function onDoc(e: MouseEvent) {
      if (!ref.current?.contains(e.target as Node)) onClose();
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="absolute bottom-full left-0 z-20 mb-2 w-72 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg"
    >
      <div className="flex border-b border-gray-100 text-xs">
        {Object.keys(GROUPS).map((g) => (
          <button
            key={g}
            type="button"
            onClick={() => setActive(g)}
            className={`flex-1 px-2 py-2 ${
              active === g ? 'bg-brand-50 font-medium text-brand-700' : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            {g}
          </button>
        ))}
      </div>
      <div className="grid max-h-52 grid-cols-8 gap-1 overflow-y-auto p-2 text-xl">
        {GROUPS[active].map((e) => (
          <button
            key={e}
            type="button"
            onClick={() => onPick(e)}
            className="rounded hover:bg-gray-100"
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
